/**
 * Created by vladislav on 10.02.2022
 */

const CupTableView = cc.Node.extend({
    ctor: function (cup, tableConstructor, options) {
        options = options || {};

        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.cup = cup;
        this.tableConstructor = tableConstructor;
        this.table = this.tableConstructor();
        this.addChild(this.table);

        this.scaleDuration = options.scaleDuration;
        this.scaleEasing = options.scaleEasing;

        this.onResize();

        this.cupStart = this.cup.start;
        this.updateState();

        this.cup.on("update", this.createListener(this.updateState.bind(this)), this);
    },

    onResize: function () {
        this.setContentSize2(this.table.getContentSize());

        this.table.setAlignment(this.width / 2, this.height / 2);
    },

    updateState: function () {
        if (this.animationRunning) {
            return;
        }

        if (this.cup.start === this.cupStart) {
            this.cup.onChangeResults();
            return;
        }

        this.animationRunning = true;

        this.hideTable(() => {
            const position = this.table.getPosition();
            this.table.removeFromParent();

            this.cup.table.updateAll(true);
            this.cupStart = this.cup.start;

            this.table = this.tableConstructor();
            this.table.setAlignment(position);
            this.addChild(this.table);

            this.showTable(() => {
                this.animationRunning = false;
            });
        });
    },

    showTable: function (callback) {
        this.table.setScale(0);
        this.table.runAction(new cc.Sequence(
            new cc.ScaleTo(this.scaleDuration || 0.5, 1).easing(this.scaleEasing || cc.easeBackOut()),
            new cc.CallFunc(callback)
        ));
    },

    hideTable: function (callback) {
        this.table.runAction(new cc.Sequence(
            new cc.ScaleTo(this.scaleDuration || 0.5, 0).easing(this.scaleEasing || cc.easeBackIn()),
            new cc.CallFunc(callback)
        ));
    }
});